import { createDecorator } from 'vue-class-component';

export default function makeDecorator(method, ...predefined) {
   return createDecorator(function _decorator(options, key) {
      options.methods[key] = function _proxy(...args) {
         // eslint-disable-next-line no-useless-call
         this[method].apply(this, [...predefined, ...args]);
      };
   });
}
